import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { AuthScope, AppPermissionScope } from '@bechtel/types';
import { CustomAuthScope } from '../types';

interface SelectedItemStyledProps {
  selectedScope: AppPermissionScope;
}

function getSelectedItemStyle({ selectedScope }: SelectedItemStyledProps) {
  switch (selectedScope.id) {
    case AuthScope.MY_WORK_PACKAGES:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[100]};
        border: solid 1px ${({ theme }) => theme.colors.blue[300]};
      `;
    case AuthScope.ALL_WORK_PACKAGES:
      return css`
        background-color: ${({ theme }) => theme.colors.green[100]};
        border: solid 1px ${({ theme }) => theme.colors.green[300]};
      `;
    case AuthScope.MY_AREA || AuthScope.ALL_AREA:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[100]};
        border: solid 1px ${({ theme }) => theme.colors.orange[300]};
      `;
    case CustomAuthScope.NONE:
      return css`
        background-color: ${({ theme }) => theme.colors.white};
        border: solid 1px ${({ theme }) => theme.colors.grey[300]};
      `;
    case AuthScope.APPLICATION:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[100]};
        border: solid 1px ${({ theme }) => theme.colors.grey[300]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[100]};
        border: solid 1px ${({ theme }) => theme.colors.purple[300]};
      `;
  }
}

export const SelectedItemStyled = styled(Box).attrs({
  p: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  flexGrow: { sm: 1 },
})<SelectedItemStyledProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    cursor: pointer;
    white-space: nowrap;
  `};

  ${getSelectedItemStyle}
`;

export const SelectBoxStyled = styled.div`
  flex-grow: 1;
`;
